export enum AuditLogTag {
  Action = 'Action',
  DateFrom = 'DateFrom',
  DateTo = 'DateTo',
  Event = 'Event',
  UserName = 'UserName'
}

export const AuditLogTagsMap = new Map<AuditLogTag, { tag: string; prop: string }>([
  [AuditLogTag.Event, { tag: 'Event', prop: 'UserActionTypeArea' }],
  [AuditLogTag.Action, { tag: 'Action', prop: 'UserActionType' }],
  [AuditLogTag.UserName, { tag: 'User name', prop: 'UserName' }],
  [AuditLogTag.DateFrom, { tag: 'Date from', prop: 'Date' }],
  [AuditLogTag.DateTo, { tag: 'To date', prop: 'Date' }]
]);
